import { render, staticRenderFns } from "./trainDate.vue?vue&type=template&id=c2b5eed6"
import script from "./trainDate.vue?vue&type=script&lang=js"
export * from "./trainDate.vue?vue&type=script&lang=js"
import style0 from "./trainDate.vue?vue&type=style&index=0&id=c2b5eed6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports